import { Column, GridApi, IRowNode } from 'ag-grid-community';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { TDocumentDefinitions } from 'pdfmake/interfaces';

// pdfMake.vfs = pdfFonts.vfs;

interface ColumnConfig {
  field: string;
  title: string;
  width: string;
}

const columnsToExport: ColumnConfig[] = [
  { field: 'rank', title: 'Rank', width: '5%' },
  { field: 'faq', title: 'Question', width: '35%' },
  { field: 'answer', title: 'Answer', width: '60%' }
];

function getFilteredColumns(gridApi: GridApi): Column[] {
  return gridApi.getAllDisplayedColumns().filter(column =>
    columnsToExport.some(c => c.field === column.getColDef().field)
  );
}

function getHeaderToExport(gridApi: GridApi): any[] {
  const columns = getFilteredColumns(gridApi);
  return columns.map(column => {
    const config = columnsToExport.find(c => c.field === column.getColDef().field)!;
    return { text: config.title, bold: true, margin: [0, 5, 0, 5] };
  });
}

function getRowsToExport(gridApi: GridApi): any[][] {
  const columns = getFilteredColumns(gridApi);
  const rowsToExport: any[][] = [];
  gridApi.forEachNode((node: IRowNode) => {
    const row = columns.map(column => {
      const field = column.getColDef().field;
      if (field === undefined) {
        return { text: '' };  // Handle undefined field by providing an empty string
      }
      const value = gridApi.getValue(field, node);
      return { text: value !== undefined && value !== null ? value.toString() : '' };
    });
    rowsToExport.push(row);
  });
  return rowsToExport;
}

function getDocument(gridApi: GridApi): TDocumentDefinitions {
  const headerRow = getHeaderToExport(gridApi);
  const rows = getRowsToExport(gridApi);
  return {
    pageOrientation: 'landscape',
    content: [{
      table: {
        headerRows: 1,
        widths: columnsToExport.map(c => c.width),
        body: [headerRow, ...rows]
      },
      layout: {
        fillColor: (rowIndex: number) => rowIndex % 2 === 0 ? '#f0f0f0' : null,
        hLineColor: () => '#ccc',
        vLineColor: () => '#ccc'
      }
    }],
    pageMargins: [40, 40, 40, 40]
  };
}

export function exportToPDF(gridApi: GridApi, filename: string): void {
  const docDefinition = getDocument(gridApi);
  pdfMake.createPdf(docDefinition).download(filename);
}
